import { render, staticRenderFns } from "./DashboardButton.vue?vue&type=template&id=6b59440c&scoped=true&"
import script from "./DashboardButton.vue?vue&type=script&lang=js&"
export * from "./DashboardButton.vue?vue&type=script&lang=js&"
import style0 from "./DashboardButton.vue?vue&type=style&index=0&id=6b59440c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59440c",
  null
  
)

export default component.exports